module.exports = __webpack_public_path__ + "static/media/Country-Club-Village-of-Plymouth-Sub-Amendment.fcc9d40a.pdf";